import React, { useState } from 'react';
import { Package, Truck, Plus, Trash2, Calculator, ArrowRight, ChevronRight } from 'lucide-react';
export function InventoryView() {
  const [activeTab, setActiveTab] = useState<'open' | 'receive' | 'close'>('receive');
  const [invoices, setInvoices] = useState([{
    id: 1,
    vendor: 'Sysco Foods',
    category: 'Food',
    subCategory: 'Dairy',
    amount: 450.25,
    date: '2026-05-30'
  }, {
    id: 2,
    vendor: 'Restaurant Depot',
    category: 'Food',
    subCategory: 'Dry Goods',
    amount: 1200.0,
    date: '2026-05-29'
  }]);
  const [openInv, setOpenInv] = useState(12500);
  const [closeInv, setCloseInv] = useState(11800);
  const totalPurchases = invoices.reduce((sum, inv) => sum + inv.amount, 0);
  const cogs = openInv + totalPurchases - closeInv;
  return <div className="space-y-6" data-id="element-329">
      <div className="flex items-center justify-between" data-id="element-330">
        <div data-id="element-331">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-332">
            Inventory & Purchasing
          </h2>
          <p className="text-sm text-slate-500" data-id="element-333">
            Manage stock levels and vendor invoices
          </p>
        </div>
        <div className="flex bg-white p-1 rounded-xl border border-slate-200 shadow-sm" data-id="element-334">
          <TabButton active={activeTab === 'open'} onClick={() => setActiveTab('open')} label="Open Inventory" data-id="element-335" />
          <TabButton active={activeTab === 'receive'} onClick={() => setActiveTab('receive')} label="Receive Invoice" data-id="element-336" />
          <TabButton active={activeTab === 'close'} onClick={() => setActiveTab('close')} label="Close Inventory" data-id="element-337" />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-338">
        <div className="lg:col-span-2 space-y-6" data-id="element-339">
          {activeTab === 'receive' && <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-340">
              <div className="p-6 border-b border-slate-50 flex items-center justify-between bg-slate-50/50" data-id="element-341">
                <div className="flex items-center gap-2" data-id="element-342">
                  <Truck className="text-blue-500" size={20} data-id="element-343" />
                  <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-344">
                    Purchase History
                  </h3>
                </div>
                <button className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg text-xs font-bold hover:bg-blue-600 transition-all" data-id="element-345">
                  <Plus size={14} data-id="element-346" />
                  Add Invoice
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-347">
                <table className="w-full text-left" data-id="element-348">
                  <thead data-id="element-349">
                    <tr className="border-b border-slate-50" data-id="element-350">
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-351">
                        Vendor
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-352">
                        Category
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-353">
                        Sub-Category
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-354">
                        Amount
                      </th>
                      <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-355"></th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50" data-id="element-356">
                    {invoices.map(inv => <tr key={inv.id} className="hover:bg-slate-50 transition-colors group" data-id="element-357">
                        <td className="px-6 py-4" data-id="element-358">
                          <p className="text-sm font-bold text-slate-900" data-id="element-359">
                            {inv.vendor}
                          </p>
                          <p className="text-[10px] text-slate-400" data-id="element-360">
                            {inv.date}
                          </p>
                        </td>
                        <td className="px-6 py-4" data-id="element-361">
                          <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-362">
                            {inv.category}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-xs font-medium text-slate-600" data-id="element-363">
                          {inv.subCategory}
                        </td>
                        <td className="px-6 py-4 text-sm font-black text-slate-900 text-right" data-id="element-364">
                          ${inv.amount.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 text-right" data-id="element-365">
                          <button className="p-2 text-slate-300 hover:text-rose-500 transition-colors" data-id="element-366">
                            <Trash2 size={14} data-id="element-367" />
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}

          {(activeTab === 'open' || activeTab === 'close') && <div className="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center text-center" data-id="element-368">
              <div className="w-16 h-16 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-500 mb-6" data-id="element-369">
                <Package size={32} data-id="element-370" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-371">
                {activeTab === 'open' ? 'Starting Inventory' : 'Ending Inventory'}
              </h3>
              <p className="text-sm text-slate-500 mb-8 max-w-xs" data-id="element-372">
                Enter the total dollar value of Food & Non-Alcoholic beverages
                currently in stock.
              </p>
              <div className="relative w-full max-w-xs" data-id="element-373">
                <DollarSign className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} data-id="element-374" />
                <input type="number" value={activeTab === 'open' ? openInv : closeInv} onChange={e => activeTab === 'open' ? setOpenInv(parseFloat(e.target.value) || 0) : setCloseInv(parseFloat(e.target.value) || 0)} className="w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-2xl font-black text-slate-900 focus:bg-white focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 outline-none transition-all" data-id="element-375" />
              </div>
              <button className="mt-8 px-8 py-3 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all flex items-center gap-2" data-id="element-376">
                Save Inventory Value <ChevronRight size={16} data-id="element-377" />
              </button>
            </div>}
        </div>

        <div className="space-y-6" data-id="element-378">
          <div className="bg-emerald-600 rounded-2xl p-6 text-white shadow-xl" data-id="element-379">
            <div className="flex items-center gap-2 mb-8" data-id="element-380">
              <Calculator className="text-emerald-200" size={20} data-id="element-381" />
              <h3 className="text-sm font-bold uppercase tracking-wider" data-id="element-382">
                COGS Calculator
              </h3>
            </div>

            <div className="space-y-6" data-id="element-383">
              <div className="flex items-center justify-between text-emerald-100" data-id="element-384">
                <span className="text-xs font-bold uppercase tracking-widest" data-id="element-385">
                  Open Inventory
                </span>
                <span className="text-sm font-bold" data-id="element-386">
                  ${openInv.toLocaleString()}
                </span>
              </div>
              <div className="flex items-center justify-between text-emerald-100" data-id="element-387">
                <span className="text-xs font-bold uppercase tracking-widest" data-id="element-388">
                  Weekly Purchases
                </span>
                <span className="text-sm font-bold" data-id="element-389">
                  + ${totalPurchases.toLocaleString()}
                </span>
              </div>
              <div className="flex items-center justify-between text-emerald-100" data-id="element-390">
                <span className="text-xs font-bold uppercase tracking-widest" data-id="element-391">
                  Close Inventory
                </span>
                <span className="text-sm font-bold" data-id="element-392">
                  - ${closeInv.toLocaleString()}
                </span>
              </div>

              <div className="pt-6 border-t border-white/20" data-id="element-393">
                <div className="flex items-center justify-between" data-id="element-394">
                  <span className="text-sm font-black uppercase tracking-widest" data-id="element-395">
                    Total COGS
                  </span>
                  <span className="text-2xl font-black" data-id="element-396">
                    ${cogs.toLocaleString()}
                  </span>
                </div>
                <p className="text-[10px] text-emerald-200 mt-2 font-medium" data-id="element-397">
                  Cost of Goods Sold for the current period.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-398">
            <h3 className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-4" data-id="element-399">
              Quick Stats
            </h3>
            <div className="space-y-4" data-id="element-400">
              <div className="flex items-center justify-between" data-id="element-401">
                <span className="text-xs font-bold text-slate-600" data-id="element-402">
                  Active Vendors
                </span>
                <span className="text-xs font-black text-slate-900" data-id="element-403">12</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-404">
                <span className="text-xs font-bold text-slate-600" data-id="element-405">
                  Pending Invoices
                </span>
                <span className="text-xs font-black text-slate-900" data-id="element-406">3</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-407">
                <span className="text-xs font-bold text-slate-600" data-id="element-408">
                  Avg. Weekly Spend
                </span>
                <span className="text-xs font-black text-slate-900" data-id="element-409">
                  $4,250
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function TabButton({
  active,
  onClick,
  label
}: any) {
  return <button onClick={onClick} className={`px-4 py-2 rounded-lg text-xs font-bold transition-all ${active ? 'bg-slate-900 text-white shadow-md' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-410">
      {label}
    </button>;
}